import styled from '@emotion/styled'

export const StyleBidirectionCardWrapper = styled.div<{
  direction?: string
  marginTop?: string
}>`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: ${(props: any) =>
    props.direction === 'reverse' ? 'row-reverse' : 'row'};
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  margin-top: ${(props: any) => props.marginTop || 5}px;
  @media (max-width: 480px) {
    flex-direction: column;
    padding: 5px 0px;
  }
`
